import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Image from 'next/image'
import 'swiper/css'
import 'swiper/css/navigation'
import { Autoplay, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import styles from './Slider.module.scss'

export default function Slider({ fields, variant }) {
  const { eyebrowText, sliderTitle, sliderContent, card } = fields
  const rootClass = variant === 'compact' ? `${styles.Slider} ${styles.compact}` : styles.Slider

  return (
    <div className={rootClass} data-aos="fade-up">
      <div className={styles.sliderContainer}>
        <div className={styles.leftColumn}>
          <span>{eyebrowText}</span>
          <h2>{sliderTitle}</h2>
          <p dangerouslySetInnerHTML={{ __html: sliderContent }}></p>
        </div>

        <div className={styles.swiperColumn}>
          <div className="prev-real">
            <FontAwesomeIcon icon={faChevronLeft} />
          </div>
          <div className="next-real">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
          <Swiper
            navigation={{ prevEl: '.prev-real', nextEl: '.next-real' }}
            spaceBetween={15}
            slidesPerView="auto"
            loop="true"
            speed={600}
            modules={[Navigation, Autoplay]}
            breakpoints={{
              769: { slidesPerView: 'auto' }
            }}
          >
            {card.map((cardItem, index) => (
              <SwiperSlide key={index} className={styles.swiperSlide}>
                <div className={styles.slideContent}>
                  {cardItem?.cardIcon?.node?.sourceUrl && (
                    <Image
                      height={63}
                      width={83}
                      alt={cardItem?.cardIcon?.node?.altText || cardItem?.cardTitle || ''}
                      src={cardItem?.cardIcon?.node?.sourceUrl}
                    />
                  )}
                  <h3>{cardItem.cardTitle}</h3>
                  <div className={styles.sliderCardContent} dangerouslySetInnerHTML={{ __html: cardItem.cardContent }} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  )
}
